<div
    class="react-mfe-app"
    [id]="mfeName"
    [class]="{ 'is-app': isApp }"
    [lazyReactComponent]="lazyLoadComponent"
    [props]="props"
>
    <app-loading *ngIf="loading"></app-loading>
    <div class="p-2" *ngIf="error">
        <app-custom-error-display [errorMessage]="'An unexpected error ocurred while loading this page.'"></app-custom-error-display>
    </div>
</div>
